import script from "./Chatbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chatbox.vue?vue&type=script&setup=true&lang=ts"

import "./Chatbox.vue?vue&type=style&index=0&id=5af2f3e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af2f3e0"]])

export default __exports__